// extracted by mini-css-extract-plugin
module.exports = {"heading":"statement-module__heading___EgZeV","body":"statement-module__body___37p0M","connect":"statement-module__connect___2K554"};